'use strict';

PopoverSelectDirective.$inject = [];

export function PopoverSelectDirective() {
  return {
    restrict: 'E',
    require: ['popoverSelect', 'ngModel', '?^^popoverSelectContainer'],
    controller: 'PopoverSelectController',
    link: function (scope, element, attr, ctrls) {

      const selectCtrl = ctrls[0];
      const ngModelCtrl = ctrls[1];
      const containerCtrl = ctrls[2];
      if (containerCtrl) containerCtrl.register(selectCtrl);

      selectCtrl.ngModelCtrl = ngModelCtrl;

      // We delegate rendering to the `writeValue` method, which can be changed
      // if the select can have multiple selected values or if the options are being
      // generated by `ngOptions`
      ngModelCtrl.$render = function () {
        selectCtrl.writeValue(ngModelCtrl.$viewValue);
      };

      // When the selected item(s) changes we delegate getting the value of the select control
      // to the `readValue` method, which can be changed if the select can have multiple
      // selected values or if the options are being generated by `ngOptions`
      element.on('change', function () {
        scope.$apply(function () {
          ngModelCtrl.$setViewValue(selectCtrl.readValue());
        });
      });

      element.on('click', function ($event) {
        $event.preventDefault();
        $event.stopPropagation();
        selectCtrl.showOptions($event);
      });

      // If the select allows multiple values then we need to modify how we read and write
      // values from and to the control; also what it means for the value to be empty and
      // we have to add an extra watch since ngModel doesn't work well with arrays - it
      // doesn't trigger rendering if only an item in the array changes.
      if (attr.multiple) {
        // TODO: consider adding support for multiple select
        // // Read value now needs to check each option to see if it is selected
        // selectCtrl.readValue = function readMultipleValue() {
        //  var array = [];
        //  forEach(element.find('option'), function(option) {
        //    if (option.selected) {
        //      array.push(option.value);
        //    }
        //  });
        //  return array;
        // };
        //
        // // Write value now needs to set the selected property of each matching option
        // selectCtrl.writeValue = function writeMultipleValue(value) {
        //  var items = new HashMap(value);
        //  forEach(element.find('option'), function(option) {
        //    option.selected = isDefined(items.get(option.value));
        //  });
        // };
        //
        // // we have to do it on each watch since ngModel watches reference, but
        // // we need to work of an array, so we need to see if anything was inserted/removed
        // var lastView, lastViewRef = NaN;
        // scope.$watch(function selectMultipleWatch() {
        //  if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
        //    lastView = shallowCopy(ngModelCtrl.$viewValue);
        //    ngModelCtrl.$render();
        //  }
        //  lastViewRef = ngModelCtrl.$viewValue;
        // });
        //
        // // If we are a multiple select then value is now a collection
        // // so the meaning of $isEmpty changes
        // ngModelCtrl.$isEmpty = function(value) {
        //  return !value || value.length === 0;
        // };

      }
    },
  };
}



// WEBPACK FOOTER //
// ./src/js/core-components/popover-select/PopoverSelectDirective.js